<p-drawer 
    [header]="dialogHeader()" 
    (onHide)="onClose.emit()" 
    [visible]="isDialogVisible()"
    position="right" 
    styleClass="!w-full md:!w-80 lg:!w-[30rem]">
    
    <div class="flex justify-between align-items-center">
    <h5> Richiesta </h5>
    <div><p-tag [value]="getRequestStatusDescription(data()?.stateId!)" [severity]="getRequestStatusSeverity(data()?.stateId!)"></p-tag></div>

    </div>
    @if(data()){
    <div class="grid grid-cols-2 gap-2 mb-4">
        <div><b>Data richiesta</b></div><div>{{data()?.requestDate | date: 'dd-MM-yyyy hh:mm'}}</div>
        <div><b>Tipo materiale</b></div><div>{{equipmentData()?.shortDescription}}</div>
        <div><b>Quantità</b></div><div>{{data()?.quantity +' '+equipmentData()?.unit}}</div>
        <div class="col-span-2"><b>Note</b></div>
        <div class="col-span-2">{{data()?.description}}</div>    
    </div>

    }
    <h5>Ordine</h5>
    <spike-equipment-request-form [isInsert]="false" [form]="form"></spike-equipment-request-form>

    <ng-template #footer>
        <div class="flex gap-4 w-full justify-between">
        @if(formView()){

            <div class="flex w-full">
                <p-button 
                    (click)="onSaveClicked()" 
                    [disabled]="form.invalid" 
                    icon="pi pi-save" 
                    label="Salva"
                    severity="primary"
                    class="w-full"
                    styleClass="w-full">
                </p-button>

            </div>
            <div class="flex gap-2">
                <p-button [disabled]="!!!data()?.requestId" (click)="formView.set(false)" icon="pi pi-times" severity="secondary" [outlined]="true"></p-button>
            </div>
        } @else {
            
                <p-button 
                    class="w-full"
                    styleClass="w-full"
                    (click)="formView.set(true)" 
                    icon="pi pi-pencil" 
                    label="Modifica"
                    severity="secondary">
                </p-button>
                
        }
        </div>
    </ng-template>
</p-drawer>
